module.exports = __webpack_public_path__ + "img/addDosnDont.cbc171d5.svg";